<div class="menu" (click)="menuClicked($event)">
  <div class="main-menu">
    <ng-scrollbar class="scroll">
      <ul class="list-unstyled">
        @for (item of menuItems; track item) {
          @if (item.hasRole) {
            <li
              [ngClass]="{'active': (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id}">
              @if (item.newWindow) {
                <a [href]="item.to" rel="noopener noreferrer" target="_blank">
                  <i [ngClass]="item.icon"></i>{{item.label | translate}}</a>
                }
                @if (!item.newWindow && item.subs &&  item.subs.length>0 && item.to) {
                  <a
                    (click)="openSubMenu($event,item); false" [href]="item.to">
                    <i [ngClass]="item.icon"></i> {{item.label | translate}}</a>
                  }
                  @if (!item.newWindow && item.subs &&  item.subs.length>0 && !item.to) {
                    <a
                      (click)="openSubMenu($event,item); false" class="c-pointer">
                      <i [ngClass]="item.icon"></i> {{item.label | translate}}</a>
                    }
                    @if (!item.newWindow && (!item.subs || (item.subs &&  item.subs.length===0))) {
                      <a
                        (click)="changeSelectedParentHasNoSubmenu(item.id); false" [routerLink]="item.to">
                        <i [ngClass]="item.icon"></i> {{item.label | translate}}</a>
                      }
                    </li>
                  }
                }
              </ul>
            </ng-scrollbar>
          </div>
          <div class="sub-menu">
            <ng-scrollbar class="scroll">
              @for (item of menuItems; track item) {
                @if (item.hasRole) {
                  <ul class="list-unstyled" [attr.data-parent]="item.id"
                    [ngClass]="{'d-block': (selectedParentMenu === item.id && viewingParentMenu==='') || viewingParentMenu === item.id}">
                    @for (sub of item.subs; track sub) {
                      @if (sub.hasRole) {
                        <li
                          [ngClass]="{'active': currentUrl === sub.to ,'has-sub-item' : sub.subs&& sub.subs.length>0 }">
                          @if (sub.newWindow) {
                            <a [href]="sub.to" rel="noopener noreferrer" target="_blank">
                              <i [ngClass]="sub.icon"></i>
                              <span class="d-inline-block">{{sub.label | translate}}</span>
                            </a>
                          }
                          @if (!sub.newWindow && (!sub.subs || sub.subs.length<=0)) {
                            <a [routerLink]="[sub.to]"
                              routerLinkActive="active">
                              <i [ngClass]="sub.icon"></i>
                              <span class="d-inline-block">{{sub.label | translate}}</span>
                            </a>
                          }
                          @if (sub.subs && sub.subs.length > 0) {
                            <a (click)="collapseSub.toggle()"
                              class="rotate-arrow-icon opacity-50 c-pointer">
                              <i class="simple-icon-arrow-down"></i>
                              <span class="d-inline-block">{{sub.label | translate}}</span>
                            </a>
                          }
                          <div [collapse]="false" #collapseSub="bs-collapse" [isAnimated]="true">
                            @if (sub.subs && sub.subs.length > 0) {
                              <div>
                                <ul class="list-unstyled inner-level-menu">
                                  @for (deepSub of sub.subs; track deepSub) {
                                    <li [ngClass]="{'active': currentUrl === deepSub.to}">
                                      @if (deepSub.newWindow) {
                                        <a [href]="deepSub.to" rel="noopener noreferrer"
                                          target="_blank">
                                          <i [ngClass]="deepSub.icon"></i>
                                          <span class="d-inline-block">{{deepSub.label | translate}}</span>
                                        </a>
                                      }
                                      @if (!deepSub.newWindow && (!deepSub.subs || deepSub.subs.length<=0)) {
                                        <a
                                          [routerLink]="[deepSub.to]" routerLinkActive="active">
                                          <i [ngClass]="deepSub.icon"></i>
                                          <span class="d-inline-block">{{deepSub.label | translate}}</span>
                                        </a>
                                      }
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        </li>
                      }
                    }
                  </ul>
                }
              }
            </ng-scrollbar>
          </div>
        </div>